import React from 'react'
import PropTypes from 'prop-types';
import find from 'lodash/find'

import {CheckoutSection, softButtonStyle} from '../../components'

import { Fade } from '../../componentAnimations'

import AddressSelectorList from './AddressSelectorList'
import AddressDisplay from './AddressDisplay'
import AddressEditorContainer from './AddressEditorContainer'

import { AddressShape, AddressActionCreatorsShape as AddressActionCreators } from './propTypes'
import { TranslationUtility } from "../../../util/translationUtility";

class CheckoutAddressComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listCollapsed: props.selectedAddressId ? false : false,
      editId: '',
      disableBillingChanges: props.disableBillingChanges
    };
    this.onClickCollapse = this.onClickCollapse.bind(this);
    this.onDoneSelecting = this.onDoneSelecting.bind(this);
    this.onBeginEdit = this.onBeginEdit.bind(this);
    this.onEndEdit = this.onEndEdit.bind(this);
    this.onEditCancel = this.onEditCancel.bind(this);
    this.translationUtility = new TranslationUtility(props.localizationItems)
  }

  onClickCollapse(e) {
    e.preventDefault();
    this.setState({ listCollapsed: !this.state.listCollapsed });
  }

  onDoneSelecting() {
    this.setState({ listCollapsed: false });
  }

  onBeginEdit(Id) {
    this.setState({ editOpen: true, editId: Id, listCollapsed: false });
  }
  
  onEndEdit() {
    this.setState({ editOpen: false });
  }

  onEditCancel() {
    this.setState({ editOpen: false, listCollapsed: false })
  }
  
  render() {
    const selectedAddress = find(this.props.addresses,
      address => address.Id === this.props.selectedAddressId);
    return (
      <Fade inProp={!this.props.hidden}>
        <CheckoutSection label={this.props.sectionLabel + ""} hidden={this.props.hidden}>

          <div className='row' style={{ minHeight: '2em' }}>
          {!this.state.disableBillingChanges || this.props.sectionLabel == 'Shipping Address' ? (<div className='col-12'>
                        <button
                            onClick={(e) => this.onClickCollapse(e)}
                            style={softButtonStyle}
                        >
                            <AddressDisplay
                                address={selectedAddress}
                                compact={true}
                                translationUtility={this.translationUtility}
                            />
                        </button>
                    </div>) : (<div className='col-12'>
                            <AddressDisplay
                                address={selectedAddress}
                                compact={true}
                                translationUtility={this.translationUtility}
                            />
                    </div>)}
          </div>
          {this.props.onUseForAnotherClicked &&
            <div className='row' style={{ minHeight: '2em' }}>
              <div className='col-12'>
              {!this.state.disableBillingChanges ? (
                <div style={{ margin: 5 }}>
                  <span
                      style={{ marginLeft: 10 }}
                      onClick={this.props.onUseForAnotherClicked}
                  >
                    <input
                        type='checkbox'
                        checked={this.props.useForAnotherSelected}
                        id='useForAnother'
                        readOnly={true} 
                    />
                    <label
                        htmlFor='#useForAnother'
                    >
                      {this.props.useForAnotherMessage}
                    </label>
                  </span>
                </div>) : (null)}
              </div>
            </div>
          }
          
          { this.state.editOpen
            ? (
              <React.Fragment>
                <hr style={{width: '90%'}} />
                <AddressEditorContainer
                    addressId={this.state.editId}
                    addressActionCreators={this.props.addressActionCreators}
                    addressType={this.props.addressType}
                    onAddressCreated={() => this.onEndEdit()}
                    onAddressUpdated={() => this.onEndEdit()}
                    onEditCancel={this.onEditCancel}
                />
              </React.Fragment>
            )
            : (
              <React.Fragment>
                <div className='row' style={{ minHeight: '2em' }}>
                {!this.state.disableBillingChanges && (typeof this.state.disableBillingChanges !== 'undefined') ? (<div className='col-12'>
                    <div style={{ margin: 5 }}>
                      <a
                          href=''
                          style={{ textDecoration: 'none' }}
                          onClick={(e) => this.onClickCollapse(e)}
                      >
                        {this.state.listCollapsed ? this.translationUtility.translateResourceString("/Checkout/Address/AddEditAddress"): this.translationUtility.translateResourceString("/Checkout/Address/Done")}
                      </a>
                    </div>
                  </div>) : (null)}
                </div>
                <Fade inProp={!this.state.listCollapsed}>
                  <AddressSelectorList
                      addressActionCreators={this.props.addressActionCreators} 
                      addresses={this.props.addresses}
                      onBeginEdit={this.onBeginEdit} 
                      onDoneSelecting={this.onDoneSelecting} 
                      selectedAddressId={this.props.selectedAddressId} selectAddressMessage={this.props.selectAddressMessage} disableBillingChanges={this.props.disableBillingChanges}/>
                </Fade>
              </React.Fragment>
            )}
        </CheckoutSection>
      </Fade>
    );
  }
}

CheckoutAddressComponent.propTypes = {
  addressActionCreators: AddressActionCreators.propTypes,
  addressType: PropTypes.number.isRequired,
  addresses: PropTypes.arrayOf(AddressShape.propTypes).isRequired,
  onUseForAnotherClicked: PropTypes.func,
  sectionLabel: PropTypes.string.isRequired,
  selectAddressMessage: PropTypes.string.isRequired,
  selectedAddressId: PropTypes.string,
  useForAnotherMessage: PropTypes.string,
  useForAnotherSelected: PropTypes.bool,
  disableBillingChanges: PropTypes.bool,
  localizationItems: PropTypes.array.isRequired
}

export default CheckoutAddressComponent;


// WEBPACK FOOTER //
// ./src/Components/checkout/Features/Address/CheckoutAddressComponent.jsx